import React from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { Benefit } from '../../../types/insurance-report-api.types';
import { PRINT_FREQUENCY_LIMITATION_COLUMNS_CONFIG } from '../../../utils/constants';
import { titleCase } from '../../../utils/utils';
import { Table } from '../common-components/table';

type PrintFrequencyAndLimitationsProps = {
  frequencyAndLimitations: Record<string, Record<string, Benefit[]>>;
  favoriteAndRequestedCDTCodes: Record<string, Benefit[]>;
};

export const PrintFrequencyAndLimitations = React.memo(
  ({ frequencyAndLimitations, favoriteAndRequestedCDTCodes }: PrintFrequencyAndLimitationsProps) => {
    const networks = Object.keys(frequencyAndLimitations || {});
    if (networks.length === 0) {
      return null;
    }

    return (
      <div css={printFrequencyAndLimitationsStyles}>
        {networks.map((network) => {
          const benefits = frequencyAndLimitations[network] || {};
          const categories = Object.keys(benefits);

          return (
            <div key={network}>
              <Heading level={2} css={headerStyles}>
                {titleCase(network || '') + ' Coverage'}
              </Heading>
              <div css={categoryStyles}>
                {favoriteAndRequestedCDTCodes[network] && favoriteAndRequestedCDTCodes[network].length > 0 && (
                  <Table
                    key='favorite-codes'
                    tableHeader='Favorite Procedures'
                    data={favoriteAndRequestedCDTCodes[network]}
                    colConfig={PRINT_FREQUENCY_LIMITATION_COLUMNS_CONFIG}
                  />
                )}
                {categories.map((category) => {
                  if (!benefits[category] || benefits[category].length === 0) {
                    return null;
                  }
                  return (
                    <Table
                      key={category}
                      tableHeader={titleCase(category || '_')}
                      data={benefits[category] || []}
                      colConfig={PRINT_FREQUENCY_LIMITATION_COLUMNS_CONFIG}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
);

PrintFrequencyAndLimitations.displayName = 'PrintFrequencyAndLimitations';

const printFrequencyAndLimitationsStyles = css`
  display: flex;
  flex-direction: column;
`;
const headerStyles = css`
  padding: 2px 0 0 ${theme.spacing(2)};
  background-color: ${theme.colors.neutral5};
  border-radius: ${theme.borderRadius.medium};
  margin: ${theme.spacing(2)} 0 ${theme.spacing(2)} 0;
  &:first-of-type {
    margin-top: 0;
  }
`;

const categoryStyles = css`
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.medium};
`;
